export enum PageType {
    MODALITY = "modality",
    EEG = "eeg",
    IMAGE = "image",
    MANUAL_DOWNSAMPLE = "manual_downsample"
}